import request from 'request/index'
import { E_PRODUCT2_RES } from 'utils/config'
export default {
  /**
   * 2.2.1.4 客户端搜索多个应用[get] /c/products/{product_id}/app?key=XXX&enable=1&os_type=1&device_type_id=1&play_type=1,2&$offset=偏移量&$limit=数量
   */
  sGetAppList ({
    product_id,
    enable = 1,
    os_type,
    play_type,
    $offset = 0,
    $limit = 10
   }) {
    return request({
      method: 'GET',
      res: E_PRODUCT2_RES,
      api: '/visitor/products/{product_id}/app',
      params: {
        product_id
      },
      query: {
        enable,
        os_type,
        play_type,
        $limit,
        $offset
      }
    })
  },
  /**
   *  2.2.1.7 获取多个应用[Post] /c/products/app/multi
   */
  sGetAppByIds (app_items) {
    return request({
      method: 'POST',
      res: E_PRODUCT2_RES,
      api: '/c/products/app/multi',
      body: {
        app_items
      }
    })
  },
  sGetAppByInfo (appId) {
    const app_items = [{
      app_id: appId
    }]
    return request({
      method: 'POST',
      res: E_PRODUCT2_RES,
      api: '/c/products/app/multi',
      body: {
        app_items
      }
    })
  },
  /**
   *  2.2.1.8 获取应用总数[get] /c/products/app/total_count?enable=1
   */
  sGetAppCount (enable) {
    return request({
      method: 'GET',
      res: E_PRODUCT2_RES,
      api: '/c/products/app/total_count',
      query: {
        enable
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/edmodo/edmodo.js